import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf_token"
import { placementSlotFields } from "../utils/trip_add_slots"

// After login from a card heart/+/thumbs click: scroll to that card, and for
// "+" or thumbs open the matching dialog via turbo stream. On search, results
// load in a lazy frame — wait for that before scrolling/opening.
export default class extends Controller {
  static values = {
    thingId: String,
    tripUrl: String,
    recommendUrl: String,
    openTripPicker: { type: Boolean, default: false },
    openRecommend: { type: Boolean, default: false },
    loc: String,
    pos: String,
    adId: String
  }

  connect() {
    if (!this.thingIdValue) return
    if (this.started) return

    this.started = true
    this.whenResultsReady(() => this.resume())
  }

  whenResultsReady(callback) {
    const frame = document.getElementById("search_results_frame")
    if (frame && !this.cardElement()) {
      frame.addEventListener("turbo:frame-load", () => callback(), { once: true })
      return
    }

    const featuredFrame = document.getElementById("featured_attractions")
    const featuredButton = document.getElementById(`featured-trip-add-button-${this.thingIdValue}`)
    if (featuredFrame && !featuredFrame.hasAttribute("complete") && !featuredButton) {
      featuredFrame.addEventListener("turbo:frame-load", () => callback(), { once: true })
      return
    }

    callback()
  }

  resume() {
    this.scrollToCard()
    if (this.openTripPickerValue && this.tripUrlValue) this.postAction(this.tripUrlValue)
    if (this.openRecommendValue && this.recommendUrlValue) this.postAction(this.recommendUrlValue)
  }

  cardElement() {
    return document.getElementById(`thing-card-wrap-${this.thingIdValue}`)
  }

  scrollToCard() {
    const card = this.cardElement()
    if (!card) return

    card.scrollIntoView({ block: "center", behavior: "smooth" })
  }

  async postAction(url) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "X-CSRF-Token": csrfToken() || "",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: new URLSearchParams(url === this.tripUrlValue ? this.tripResumeBody() : { thing_id: this.thingIdValue }),
      credentials: "same-origin"
    })

    if (!response.ok) return

    const html = await response.text()
    if (html) window.Turbo.renderStreamMessage(html)
  }

  tripResumeBody() {
    const body = { thing_id: this.thingIdValue, resume: "1" }
    if (this.locValue) body.loc = this.locValue
    if (this.posValue) body.pos = this.posValue
    if (this.adIdValue) body.ad_id = this.adIdValue
    return { ...body, ...placementSlotFields(this.thingIdValue) }
  }
}
